export default "__VITE_ASSET__KjGzGIZR__"